/** The promoter's share page (no sign-in) on the referrals app that served the offer link, or null without both. */
export function sharePageUrlFor(shareOfferUrl: string | undefined, contactUid: string | undefined): string | null {
  const uid = contactUid?.trim();
  if (!shareOfferUrl || !uid) return null;
  try {
    return `${new URL(shareOfferUrl).origin}/share/${encodeURIComponent(uid)}/`;
  } catch {
    return null;
  }
}
